import { cloneDeep } from 'lodash';

import { IGroup } from '../../../../../state/app/collections/dataTypes';
import {
    IEditObjectDialogFormValues,
    TMonitoredObjectDataForm,
} from '../types';
import {
    IRegistryVehicle,
    TObjectRegistry,
} from '../../../../../state/app/registers/monitoredObjects';

import { IEntityAttribute } from '../../../../../state/types';
import { getAttributesPayload } from '../../../../../features/Attributes/utils';

const isVehicleRegistry = (
    registry: TObjectRegistry
): registry is IRegistryVehicle => {
    return 'fuelConsumptionType' in registry;
};

export const prepareVehicleRegistry = (
    registry: IRegistryVehicle
): IRegistryVehicle => {
    const data = cloneDeep(registry);

    if (registry.fuelConsumptionType === 'mth') {
        data.fuelConsumptionWork = data.fuelConsumption;
        data.fuelConsumption = 0;
    } else {
        data.fuelConsumption = registry.fuelConsumption;
        data.fuelConsumptionWork = 0;
    }

    return data;
};

const prepareObjectData = (values: TMonitoredObjectDataForm) => {
    const { externalId, id, type, name, registry } = values;

    const groupIds = values.groups?.map((group: IGroup) => group.id) || [];
    if (!externalId || !id || !type || !name || !registry || !groupIds.length) {
        return null;
    }

    const processedRegistry = isVehicleRegistry(registry)
        ? prepareVehicleRegistry(registry)
        : registry;

    return {
        name,
        externalId,
        id,
        type,
        registry: processedRegistry,
        timeZone: values.timeZone
            ? {
                  id: values.timeZone.id,
                  name: values.timeZone.name,
              }
            : undefined,
        groupIds,
    };
};

export const prepareMonitoredObject = (values: IEditObjectDialogFormValues) => {
    const data = prepareObjectData(values.data);
    const registryAttributes: IEntityAttribute[] = getAttributesPayload(
        values.attributes
    );
    if (!data) {
        return;
    }
    return { ...data, registryAttributes };
};
